import { __rest } from '../../_virtual/_tslib.js';
import React from 'react';
import PropTypes from 'prop-types';
import styles from '../../node_modules/@flixbus/honeycomb/dist/scss/components/tag.scss.js';
import HoneyBem from '../../packages/honey-bem/honey-bem.js';
import * as reactUtils from '../../packages/react-utils/react-utils.js';
import * as propsUtils from '../../packages/props-utils/props-utils.js';
import { InnerRefPropType } from '../../packages/props-utils/prop-types.js';
import { TAG_ELEMS, TAG_DISPLAYS, TAG_APPEARANCES } from './types.js';
import Button from '../button/button.js';
import { Injecss } from '../../packages/injecss/injecss.js';

const bem = new HoneyBem('tag', styles);
/** @since 0.2.0 */
function Tag(_a) {
  var {
      appearance,
      children,
      closeProps,
      disabled = false,
      display,
      Elem = 'div',
      extraClasses,
      innerRef,
      small = false,
      tagColor,
      tagTextColor,
      style
    } = _a,
    rest = __rest(_a, ["appearance", "children", "closeProps", "disabled", "display", "Elem", "extraClasses", "innerRef", "small", "tagColor", "tagTextColor", "style"]);
  const computedDisable = Elem === 'button' ? {
    disabled
  } : null;
  const ariaDisabled = disabled ? {
    'aria-disabled': disabled
  } : {};
  /* @ts-expect-error ReactNode expected in second parameter */
  const tagChildren = reactUtils.mapRecursively(children, child => {
    if (reactUtils.getElementName(child) === 'Icon') {
      return /*#__PURE__*/React.cloneElement(child, {
        extraClasses: propsUtils.handleExtraClasses(child, bem.e('icon'))
      });
    }
    return child;
  });
  const tagStyle = Object.assign(Object.assign(Object.assign({}, tagColor ? {
    '--hcr-tag-color': tagColor
  } : {}), tagTextColor ? {
    '--hcr-tag-text-color': tagTextColor
  } : {}), style);
  return /*#__PURE__*/React.createElement(Elem, Object.assign({
    ref: innerRef,
    className: bem.b([appearance, display, {
      disabled,
      small
    }], extraClasses),
    style: tagStyle
  }, computedDisable, ariaDisabled, rest), tagChildren, closeProps && (/*#__PURE__*/React.createElement(Button, Object.assign({
    extraClasses: bem.e('close'),
    "aria-label": closeProps.label,
    appearance: "link",
    display: "square",
    size: "sm"
  }, closeProps))));
}
Tag.displayName = 'Tag';
Tag.propTypes = {
  children: PropTypes.node.isRequired,
  appearance: PropTypes.oneOf(TAG_APPEARANCES),
  display: PropTypes.oneOf(TAG_DISPLAYS),
  disabled: PropTypes.bool,
  Elem: PropTypes.oneOf(TAG_ELEMS),
  extraClasses: PropTypes.string,
  innerRef: InnerRefPropType,
  small: PropTypes.bool,
  closeProps: _ref => {
    let {
      closeProps
    } = _ref;
    // if has closeProps then must have label and onclick
    if (closeProps) {
      if (!closeProps.label) {
        return new Error('`closeProps.label` is required if you provide `closeProps`');
      }
      if (!closeProps.onClick) {
        return new Error('`closeProps.onClick` is required if you provide `closeProps`');
      }
    }
    return null;
  },
  tagColor: PropTypes.string,
  tagTextColor: PropTypes.string
};
var Tag$1 = Injecss(Tag, styles);

export { Tag, Tag$1 as default };
